import { render, staticRenderFns } from "./OkVidePlayer.vue?vue&type=template&id=f6b02c06&"
import script from "./OkVidePlayer.vue?vue&type=script&lang=js&"
export * from "./OkVidePlayer.vue?vue&type=script&lang=js&"
import style0 from "./OkVidePlayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports